export enum MainRoutes {
  AppSignUrls = 'app-sign-urls',
  Check = 'check',
  ConvertCsvToJson = 'convert-csv-to-json',
  ConvertJsonToCsv = 'convert-json-to-csv',
  Error = 'error',
  LocalSignUrls = 'local-sign-urls',
  Order = 'order',
  Ping = 'ping',
  RealTimeApiTest = 'real-time-api-test',
  Slack = 'slack',
}
